import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/me/shop/cashbills";

export const cashbill = {
    // ...example,
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    print(data){
        return axios.get(`${url}/${data._id}`, data).then(result => result.data);
    }
}
